import { Injectable } from '@angular/core';
import { Color, Style } from '../models/new/style';
import {
	AspectRatio,
	MediaFormat,
	Shot,
	ShotApprovalStatus,
	ShotType
} from '../models/new/shot';
import { MediaShareColorShots, MediaShareDetail } from '../models/new/media-share-detail';

@Injectable({
	providedIn: 'root'
})
export class MediaShareDetailMapper {
	toMediaShareDetails(nodes: any[]): MediaShareDetail[] {
		return (nodes || []).map((node) => this.toMediaShareDetail(node));
	}

	private toMediaShareDetail(node: any): MediaShareDetail {
		return {
			opened: true,
			style: new Style({

				modelId: node.style?.modelId,
				code: node.style?.code,
				name: node.style?.name
			}),
			colors: (node.colors || []).map((colorNode: any) => this.toColorShots(colorNode))
		};
	}

	private toColorShots(colorNode: any): MediaShareColorShots {
		const shots = (colorNode.shots || []).map((shot: any) => this.toShot(shot));

		return {
			mediaShareLinkDetailId: colorNode.mediaShareLinkDetailId,
			color: new Color({
				id: colorNode.color?.id,
				code: colorNode.color?.code,
				name: colorNode.color?.finalColorName || colorNode.color?.name
			}),
			shots,
			isAi: shots.some((shot: Shot) => !!shot.isAi)
		};
	}

	private toShot(shot: any): Shot {
		return new Shot({
			id: shot.shotId,
			mandatory: shot.mandatory,
			imgPath: shot.imgPath,
			isAi: shot.isAi,
			estimatedFileName: shot.estimatedFileName,
			shotApprovalStatus: shot.shotApprovalStatusId as ShotApprovalStatus,
			mediaFormat: shot.mediaFormat
				? new MediaFormat({ id: shot.mediaFormat.id, name: shot.mediaFormat.label })
				: undefined,
			aspectRatio: shot.aspectRatio
				? new AspectRatio({ id: shot.aspectRatio.id, label: shot.aspectRatio.label })
				: undefined,
			shotType: shot.shotType ? new ShotType({ id: shot.shotType.id, name: shot.shotType.label }) : undefined
		});
	}
}
